/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, Typography } from 'design-system';
import { ExclamationCircleIcon } from 'design-system/components/Icons';

export default function OutcomeFooterNote({ children }) {
  return (
    <FlexRow
      align="center"
      fullWidth={false}
      gap="var(--ds-space-2)"
      className="ld-outcome__footer-note"
    >
      <ExclamationCircleIcon
        size={14}
        className="ds-icon--color-muted"
        aria-hidden
      />
      <Typography component="p" variant="bodySmall" color="ui-subtle">
        {children}
      </Typography>
    </FlexRow>
  );
}

OutcomeFooterNote.propTypes = {
  children: PropTypes.node.isRequired,
};
